export default "<li class=\"pmenuitem\">\n\n    <js-templateNonce></js-templateNonce>\n    {{- label }}</li>";